import { langUtils } from "./utilities";

export const dashboard = {
  appName: "Smart Eyes",
  nameTrail: "Optical",
  banner: {
    [langUtils.english]:
      "Find the perfect vision solution just for you from our wide range of designer eyewear and lenses tailored to your needs.",
    [langUtils.portugese]:
      "Encontre a solução de visão perfeita para você em nossa ampla gama de óculos e lentes de grife adaptadas às suas necessidades.",
  },
  bannerButton: {
    [langUtils.english]: "Call Us",
    [langUtils.portugese]: "Ligue para nós",
  },
};

export const aboutUs = {
  title: {
    [langUtils.english]: "About Us",
    [langUtils.portugese]: "Sobre nós",
  },
  content: [
    {
      [langUtils.english]:
        "Welcome to <strong>Smart Eyes Opticals</strong>, where our mission is to provide exceptional eye care services to our patients. We are a team of dedicated optometrists who are committed to preserving and enhancing the gift of sight.",
      [langUtils.portugese]:
        "Bem-vindo à <strong>Smart Eyes Opticals</strong>, onde nossa missão é fornecer serviços oftalmológicos excepcionais aos nossos pacientes. Nós somos uma equipe de optometristas dedicados que estão comprometidos em preservar e aprimorando o dom da visão.",
    },
    {
      [langUtils.english]:
        "At our clinic, we understand the importance of healthy eyes and the role they play in our daily lives. We are committed to providing comprehensive eye exams, personalized treatment plans, and the latest in eye care technology to ensure that our patients receive the best possible care.",
      [langUtils.portugese]:
        "Em nossa clínica, entendemos a importância de olhos saudáveis e o papel que eles desempenham em nossa vida diária. Estamos comprometidos em fornecer exames oftalmológicos abrangentes, planos de tratamento personalizados e a mais recente tecnologia em cuidados oftalmológicos para garantir que nossos pacientes recebam o melhor atendimento possível.",
    },
    {
      [langUtils.english]:
        "Our team of highly trained optometrists, opticians, and staff members work together to provide a comfortable and welcoming environment for our patients. We strive to create a personalized experience for each patient and take the time to listen to their concerns and needs.",
      [langUtils.portugese]:
        "Nossa equipe de optometristas, oftalmologistas e funcionários altamente treinados trabalha em conjunto para proporcionar um ambiente confortável e acolhedor para nossos pacientes. Nós nos esforçamos para criar uma experiência personalizada para cada paciente e dedicamos tempo para ouvir suas preocupações e necessidades.",
    },
  ],
};

export const services = {
  title: {
    [langUtils.english]: "Our Services",
    [langUtils.portugese]: "Nossos serviços",
  },
};

export const gallary = {
  title: {
    [langUtils.english]: "Gallary",
    [langUtils.portugese]: "Galeria",
  },
};

export const optomLang = {
  title: {
    [langUtils.english]: "Owner",
    [langUtils.portugese]: "Proprietário",
  },
  designation: {
    [langUtils.english]: "Optometrist & Contact Lens Specialist",
    [langUtils.portugese]: "Optometrista e especialista em lentes de contato",
  },
  content: [
    {
      [langUtils.english]:
        "<strong>Gyan Paliwal </strong> is a healthcare professional who specializes in diagnosing and treating vision problems and contact lenses. He performs eye exams, prescribe corrective lenses, and provide other types of vision care. He is experienced in detecting and managing a wide range of eye conditions, including refractive errors (e.g. nearsightedness, farsightedness, astigmatism), binocular vision disorders, and ocular diseases (e.g. glaucoma, cataracts).",
      [langUtils.portugese]:
        "<strong>Gyan Paliwal </strong> é um profissional de saúde especializado no diagnóstico e tratamento de problemas de visão e lentes de contato. Ele realiza exames oftalmológicos, prescreve lentes corretivas e fornece outros tipos de cuidados com a visão. Ele tem experiência na detecção e gerenciamento de uma ampla gama de condições oculares, incluindo erros de refração (por exemplo, miopia, hipermetropia, astigmatismo), distúrbios da visão binocular e doenças oculares (por exemplo, glaucoma, catarata).",
    },
    {
      [langUtils.english]:
        "He also works closely with ophthalmologists, who are medical doctors specializing in eye care and surgery, to manage more complex eye conditions.",
      [langUtils.portugese]:
        "Ele também trabalha em estreita colaboração com oftalmologistas, que são médicos especializados em cuidados com os olhos e cirurgia, para lidar com condições oculares mais complexas.",
    },
  ],
};

export const contactUs = {
  title: {
    [langUtils.english]: "Contact Us",
    [langUtils.portugese]: "Contate-nos",
  },
  subTitleLeft: {
    [langUtils.english]: "Locate Us",
    [langUtils.portugese]: "Localize-nos",
  },
  subTitleRight: {
    [langUtils.english]: "Connect with Us",
    [langUtils.portugese]: "Conecte-se conosco",
  },
};
